import ToggleFeatureFlagsPage from "./ToggleFeatureFlagsPage";

import {
  Card,
  Container
} from "react-bootstrap";

import "./FeatureFlagPage.scss"

export default function FeatureFlagPage() {
  return (
    <Container id="featureFlagPage">
      <h3 id="pageHeader">Conditional Feature Flags</h3>
      <Card className="bg-white border-0 flagCard">
        <Card.Header>
          <h5>How to utilize Feature Flags</h5>
        </Card.Header>
        <Card.Body>
          <p>Conditional Feature Flags are utilized as master switches to the availability of certain features.
          These can be a global on/off switch for a feature or more granular at a tenant or facility level.
          If a flag is not enabled, it will ignore all dates and the more granular enablements and will not be available to anyone.
          This can be utilized to schedule initial rollouts or remove functionality from production without an elevate in the case of defects.
          The global start and end dates can be utilized to scheduled when the functionality is available once the flag is enabled.
          These dates can be more granular at the facility or tenant level as well.
          If no tenants or facilities are assigned, the flag functions as a global on/off switch.
            Once a tenant or facility is associated, only those associated will have access once the flag is enabled.</p>
        </Card.Body>
      </Card>
      <ToggleFeatureFlagsPage />
    </Container>
  );
}
